import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4" }
const _hoisted_2 = { class: "flex gap-4 flex-col items-start md:flex-row md:justify-between md:items-center" }
const _hoisted_3 = { class: "text-4xl" }
const _hoisted_4 = {
  key: 0,
  class: "border rounded shadow p-5"
}
const _hoisted_5 = { class: "font-semibold flex items-center gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-arrow-down"
}
const _hoisted_7 = { class: "flex flex-wrap items-center justify-center gap-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { computed, onBeforeMount, onMounted, ref } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PInputText from "primevue/inputtext";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import CButton from "@/components/Button.vue";
import { useI18n } from "vue-i18n";
import PConfirmDialog from "primevue/confirmdialog";
import { useConfirm } from "primevue/useconfirm";
import { useStore } from "vuex";
import { useNotify } from "@/composables/useNotify";
import TeamMemberForm from "@/pages/settings/teamMembers/TeamMemberForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isShowCreateNew = ref(false);
const { t } = useI18n();
const { successToast, errorToast } = useNotify({ t });
const toggleCreateNew = (show: boolean) => {
  isShowCreateNew.value = show;
  closeAll();
};
const activeTeamMember = ref(-1);
const store = useStore();
const confirm = useConfirm();

const tenant = computed(() => store.getters["tenant/info"]);
const teamMembers = computed<any>(() => tenant.value?.teamMembers);
const retrieveTenant = async () => {
  await store.dispatch("tenant/RETRIEVE", {
    tenantId: store.getters["user/info"]?.tenantId,
  });
};

const canShowEditButtonsOnTeamMembers = computed(() => {
  return activeTeamMember.value < 0 && !isShowCreateNew.value;
});
const selectTeamMember = (index: number) => {
  activeTeamMember.value = index;
};
const closeAll = () => {
  activeTeamMember.value = -1;
};

onBeforeMount(async () => {
  await retrieveTenant();
});

const createTeamMember = async (teamMember: any) => {
  try {
    await store.dispatch("teamMember/CREATE_TEAM_MEMBER", teamMember);
    toggleCreateNew(false);
    successToast({ title: t("teamMember"), detail: t("createdSuccessfully") });

    await retrieveTenant();
  } catch (e: any) {
    errorToast({ title: t("teamMember"), error: e.message });
  }
};
const updateTeamMember = async (teamMember: any) => {
  try {
    await store.dispatch("teamMember/UPDATE_TEAM_MEMBER", teamMember);
    closeAll();
    successToast({ title: t("teamMember"), detail: t("updatedSuccessfully") });
    await retrieveTenant();
  } catch (e: any) {
    errorToast({ title: t("teamMember"), error: e.message });
  }
};
const deleteTeamMember = async (teamMember: any) => {
  confirm.require({
    message: `${t("deletingTeamMember")} ${teamMember.firstName ?? ""} ${
      teamMember.lastName ?? ""
    } `,
    header: t("confirmation"),
    icon: "pi pi-exclamation-triangle",
    accept: async () => {
      try {
        await store.dispatch("teamMember/DELETE_TEAM_MEMBER", teamMember);
        await retrieveTenant();
        successToast({
          title: t("teamMember"),
          detail: t("deletedSuccessfully"),
        });
      } catch (e: any) {
        errorToast({ title: t("teamMember"), error: e.message });
      }
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_unref(PConfirmDialog)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("teamMembers")), 1),
        (!isShowCreateNew.value)
          ? (_openBlock(), _createBlock(CButton, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCreateNew(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("addATeamMember")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_Transition, { name: "toggleable-content" }, {
        default: _withCtx(() => [
          (isShowCreateNew.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(TeamMemberForm, {
                  onCancel: _cache[1] || (_cache[1] = ($event: any) => (toggleCreateNew(false))),
                  onSave: createTeamMember
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_unref(Accordion), {
          activeIndex: activeTeamMember.value,
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop","prevent"]))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(teamMembers), (teamMember, teamMemberIndex) => {
              return (_openBlock(), _createBlock(_unref(AccordionTab), {
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"])),
                key: teamMemberIndex
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
                    class: "flex flex-col md:flex-row justify-between items-center w-full gap-y-2 p-5"
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(teamMember.firstName ?? "") + " " + _toDisplayString(teamMember.lastName ?? ""), 1),
                      (teamMemberIndex === activeTeamMember.value)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("i", {
                        class: _normalizeClass([{ invisible: !_unref(canShowEditButtonsOnTeamMembers) }, "pi pi-pencil hover:cursor-pointer"]),
                        onClick: ($event: any) => (selectTeamMember(teamMemberIndex))
                      }, null, 10, _hoisted_8),
                      _createElementVNode("i", {
                        class: "pi pi-trash hover:cursor-pointer",
                        onClick: ($event: any) => (deleteTeamMember(teamMember))
                      }, null, 8, _hoisted_9)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(TeamMemberForm, {
                    "is-update": "",
                    "team-member": teamMember,
                    onCancel: _cache[3] || (_cache[3] = ($event: any) => (closeAll())),
                    onSave: updateTeamMember
                  }, null, 8, ["team-member"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ])
    ])
  ]))
}
}

})